type GroupLinks = {
  avatar: BB.Link;
  html: BB.Link;
  self: BB.Link;
};

type Group = {
  account_privilege: null | BB.AccountPrivilege;
  default_permission: BB.Privilege;
  email_forwarding_disabled: boolean;
  default_for_workspace_slug: string | null;
  full_slug: string;
  links: Omit<GroupLinks, 'avatar'>;
  name: string;
  owner: BB.Team | BB.User;
  slug: string;
  type: 'group' | 'user';
  workspace: BB.Workspace;
};

declare global {
  namespace BB {
    type InternalGroup = Group;
  }
}

export type InternalGroup = Group;
